<!--  -->
<template>
  <div class="content">
    <cx-head v-if="windowWidth<=768"/>
    <b-container fluid>
      <img
        class="top_img"
        width="100%"
        src="../../static/img/contact/top_img.png"
      />
      <img
        class="top_img1"
        width="100%"
        src="../../static/img/contact/top.png"
      />
    </b-container>
    <!-- <div
      class="mianbao"
      toggleable="lg"
    >
      <div
        v-for="(item,index) in mianbaoList"
        :key="index"
        class="mianbao_item"
        :class="{active:index==i}"
      >{{item.label}}</div>
    </div> -->
    <div class="service_content">
      <div class="service_view">
        <div class="service_left">
          <img
            class="img1"
            width="188"
            src="../../static/img/contact/title1.png"
          />
          <div class="title_text">联系我们</div>
          <div class="contact_text">
            <!-- 快乐车行拥有湖南省长沙市望城区光明村露营地，拥有一站式房车旅游社交电商平台“约你游”。
            “约你游”作为战略的线上平台，是一个集房车租赁、营地预定、共享房车、房车旅行、攻略游记、房车约游等功能于一体的一站式房车旅游社交电商平台。
            2020快乐车行推出线下的“房车驿站”，在全国景区、景区沿线及大中小城市铺设房车驿站，每个房车驿站都会配备智能水电桩及创富机，为全国的房车爱好者提供食物、布草、洗漱用品等补给。 -->
            <!-- <br /> -->
            <br />
            联系电话：4000-155-105
            <br />
            <!-- 邮件：13126818@qq.com -->
            <br />
            联系地址：湖南省长沙市望城区白箬铺镇光明村（伊宅购快乐车行房车露营基地）
          </div>
        </div>
        <div class="service_right">
          <img
            width="100%"
            src="../../static/img/contact/ic_map.png"
          />
        </div>
      </div>
      <div class="code_view">
        <div class="code_title">快扫描下方二维码关注我们吧</div>
        <div class="code_list">
          <div
            class="code_item"
            v-for="(item,index) in codeList"
            :key="index"
          >
            <img
              width="172"
              :src="item.img"
            />
            <div>{{item.text}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="partner_view">
      <div class="title_img">
        <img width="700" src="../../static/img/contact/title2.png" />

      </div>
      <div class="partner_list">
        <div
          class="partner_item"
          v-for="(item,index) in partnerList"
          :key="index"
        >
          <div style="font-weight:bold;margin-bottom:10px">{{item.title}}</div>
          <div>{{item.tel}}</div>
        </div>
      </div>
      <div class="partner_bottom">
        伊宅购快乐车行诚挚地向您发出邀请，如果您的营地需要更多游客资源，如果您的房车想要合作获取利润，如果您的商铺需要更多游客消费，如果您需要钱钱钱，那么就请来联系我们吧！或者将您所在区域的营地、房车以及合作意向资料发邮件至LiXin@ezagoo.conm。
      </div>
    </div> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
    cxHead,
  },
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
      windowWidth: window.innerWidth,
			pageName: '',
			SeoKeyword: '',
			SeoDescription: '',
			i: 0,
			mianbaoList: [
				{
					label: '联系我们',
					path: '#',
				},
				// {
				// 	label: '合作洽谈',
				// 	path: '#',
				// },
			],
			codeList: [
				// {
				// 	img: '../../static/img/contact/ic_code.png',
				// 	text: '快乐车行公众号',
				// },
				{
					img: '../../static/img/contact/ic_code1.jpg',
					text: '约你游公众号',
				},
				{
					img: '../../static/img/contact/ic_code.png',
					text: '约你游APP下载',
				},
				{
					img: '../../static/img/contact/ic_code3.jpg',
					text: '约你游官方微博',
				},
			],
			partnerList: [
				{
					title: '合作项目',
					tel: '李总（156 7514 6876）',
				},
				{
					title: '华南、西南片区',
					tel: '肖总（136 7731 2460）',
				},
				{
					title: '东北、西北片区',
					tel: '程总（156 7317 6595）',
				},
				{
					title: '华中、华东片区',
					tel: '李总（156 7514 6876）',
				},
			],
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function(response) {
					// console.log('seo优化', response);
					let data = response.data;
					that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
					that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: '约你游·一站式房车旅游综合服务平台';
				})
				.catch(function(error) {
					console.log(error);
				});
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getSiteData();
	},
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
	padding-bottom: 60px;
}
.container-fluid {
	padding-left: 0 !important;
	padding-right: 0 !important;
}
.mianbao {
	display: flex;
	flex-direction: row;
	align-items: center;
	background: #fbfbfb;
	font-size: 14px;
	padding: 4px;
}
@media (min-width: 768px) {
	// .mianbao {
	// 	padding-left: 200px;
	// }
	.service_title {
		display: none;
	}
	.title_text {
		display: none;
	}
}

@media (max-width: 576px) {
  .top_img{
    display: none
  }
  .top_img1{
    display: block
  }
	.img1 {
		display: none;
	}
	.contact_text {
		margin: 0 25px !important;
	}
	.title_text {
		color: #222222;
		font-size: 20px;
		font-weight: bold;
		text-align: start;
		display: block !important;
		margin-top: 15px;
		margin-left: 25px;
	}
	.mianbao_item {
		flex: 1;
	}
	.mianbao {
		display: none;
	}
	.service_mid {
		display: none;
	}

.service_right{
  margin: 25px !important
}
.code_title{
  margin-left: 25px !important
}
	// .service_left img {
	// 	display: none;
	// }
	.code_list {
		display: flex;
		flex-direction: row;
		font-size: 12px;
		text-align: center;
		overflow: auto;
		margin: 10px;
    justify-content: space-between
	}
	.code_item {
		margin: 5px 15px;
    img{
      width: 86px
    }
	}
	.partner_view img {
		display: none;
	}
	.partner_list {
		display: flex;
		flex-direction: row;
		font-size: 14px;
		text-align: left;
		overflow: auto;
		margin: 10px;
		flex-wrap: wrap;
		justify-content: center;
	}
	.partner_item {
		margin: 10px;
	}
}

.mianbao_item {
	margin: 0 20px;
	cursor: pointer;
}
.active {
	color: #ff6537;
	font-weight: bold;
}

.service_left img {
	margin-left: 14px;
}

@media (min-width: 768px) {
  .top_img1{
    display: none
  }
  .top_img{
    display: block
  }
	.service_view {
		display: flex;
		flex-direction: row;
		margin: 40px auto;
		font-size: 14px;
		text-align: left;
		width: 1200px;
	}
	.service_right {
		flex: 1;
		text-align: center;
	}
	.service_right img {
		width: 400px;
		border: 1px solid #eee;
		padding: 10px;
	}
	.service_left {
		text-align: start;
		line-height: 1.8;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.code_view {
		width: 1200px;
		margin: 40px auto;
	}
	.code_list {
		display: flex;
		flex-direction: row;
		font-size: 14px;
		text-align: center;
		overflow: auto;
		margin: 60px 10px;
		justify-content: center;
	}
	.code_item {
		margin: 5px 30px;
	}
	.partner_view {
		width: 100%;
		margin: 40px auto;
		background: #f6f6f6;
		padding: 40px 0;
	}
	.partner_list {
		display: flex;
		flex-direction: row;
		font-size: 14px;
		text-align: left;
		overflow: auto;
		margin: 30px 10px;
		justify-content: center;
	}
	.partner_item {
		margin: 10px 30px;
	}
	.partner_bottom {
		width: 820px;
		margin: 0 auto;
		text-align: justify;
		font-size: 14px;
	}
}
.contact_text {
	margin: 0 14px;
	margin-top: 20px;
}
.service_view {
	margin-top: 40px;
	text-align: left;
}
.service_right {
	margin: 10px;
	text-align: center;
}
.code_title {
	text-align: left;
	font-weight: bold;
	font-size: 20px;
	margin-top: 10px;
	margin-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/page/contact.vue